import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ChevronLeft, Loader2 } from "lucide-react";

const Card = ({ title, children }) => (
  <section className="rounded-xl border border-border bg-white p-5">
    <h3 className="font-heading text-base font-semibold mb-3">{title}</h3>
    {children}
  </section>
);

export const LearnerProfile = ({ api, learner, onUpdated, onBack }) => {
  const [name, setName] = useState(learner?.name || "");
  const [pw, setPw] = useState({ current_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState("");

  const saveName = async (e) => {
    e.preventDefault(); setSaving("name");
    try { const { data } = await api.patch("/learner/me", { name }); onUpdated(data); toast.success("Name updated"); }
    catch (err) { toast.error(err.response?.data?.detail || "Update failed"); }
    finally { setSaving(""); }
  };

  const savePw = async (e) => {
    e.preventDefault();
    if (pw.new_password !== pw.confirm) { toast.error("New passwords don't match"); return; }
    setSaving("pw");
    try {
      await api.post("/learner/change-password", { current_password: pw.current_password, new_password: pw.new_password });
      setPw({ current_password: "", new_password: "", confirm: "" }); toast.success("Password changed");
    } catch (err) { toast.error(err.response?.data?.detail || "Password change failed"); }
    finally { setSaving(""); }
  };

  return (
    <div className="space-y-4" data-testid="learner-profile">
      <button onClick={onBack} className="text-xs text-muted-foreground hover:text-foreground flex items-center gap-1" data-testid="profile-back"><ChevronLeft size={12} /> My courses</button>
      <h2 className="font-heading text-2xl font-semibold">My profile</h2>
      <Card title="Your details">
        <form onSubmit={saveName} className="space-y-3 max-w-md">
          <div><Label className="text-xs">Email</Label><Input value={learner?.email || ""} disabled data-testid="profile-email" /></div>
          <div><Label className="text-xs">Full name</Label><Input value={name} onChange={(e) => setName(e.target.value)} required data-testid="profile-name" /></div>
          <Button type="submit" disabled={saving === "name"} className="bg-green-700 hover:bg-green-800 text-white" data-testid="profile-save-name">
            {saving === "name" ? <Loader2 size={14} className="animate-spin" /> : "Save name"}
          </Button>
        </form>
      </Card>
      <Card title="Change password">
        <form onSubmit={savePw} className="space-y-3 max-w-md">
          <div><Label className="text-xs">Current password</Label><Input type="password" value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} required data-testid="profile-current-pw" /></div>
          <div><Label className="text-xs">New password (min 8 characters)</Label><Input type="password" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} required data-testid="profile-new-pw" /></div>
          <div><Label className="text-xs">Confirm new password</Label><Input type="password" value={pw.confirm} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} required data-testid="profile-confirm-pw" /></div>
          <Button type="submit" disabled={saving === "pw"} className="bg-green-700 hover:bg-green-800 text-white" data-testid="profile-save-pw">
            {saving === "pw" ? <Loader2 size={14} className="animate-spin" /> : "Change password"}
          </Button>
        </form>
      </Card>
    </div>
  );
};
